import { render, staticRenderFns } from "./PersonalIdExampleConfirm.vue?vue&type=template&id=592c412c&scoped=true&"
import script from "./PersonalIdExampleConfirm.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdExampleConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdExampleConfirm.vue?vue&type=style&index=0&id=592c412c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c412c",
  null
  
)

export default component.exports